<template>
    <nav style="margin-top:20px" :class="{ 'pagine-mobile': $root.isMobile }">
        <Pag
            v-model="localValue"
            :page-count="numpagine"
            :container-class="'pagination' + ($root.isMobile ? ' pagination-sm flex-wrap justify-content-center' : '')"
            :first-last-button="!$root.isMobile"
            :page-link-class="'page-link'"
            :next-link-class="'page-link'"
            :prev-link-class="'page-link'"
            :active-class="'active'"
            :first-button-text="'<<'"
            :last-button-text="'>>'"
            :next-text="'>'"
            :prev-text="'<'"
            :page-range="$root.isMobile ? 2 : 3"
            :margin-pages="$root.isMobile ? 1 : 1"
            :numrighe="$root.isMobile ? null : numrighe"
            :pdf="pdf"
            :xlsx="xlsx"
            :csv="csv"
            @esportazione="esportazione($event)">
        </Pag>
        <!-- Tot righe compatto per mobile -->
        <div v-if="$root.isMobile && numrighe" class="text-center mt-2" style="font-size: 0.75rem; color: #6c757d;">
            Tot: {{ numrighe }}
        </div>
    </nav>
</template>
<script>
import Pag from '@/components/utils/Pag.vue'


export default {
    name: 'Pagine',
    components: {
        Pag
    },
    props: {
        options: {
          
        },
        modelValue: Number,
        numpagine: {
          type: Number,
        },
        numrighe: {
            type: Number,
        },
        pdf:{
            type:Boolean,
            default : false
        },
        xlsx:{
            type:Boolean,
            default : false
        },
        csv:{
            type:Boolean,
            default : false
        }
    },
    emits: ['update:modelValue'],

    data:function(){
        return{
            //CREO UN VALORE COPIA DEL VALORE IN INPUT PERCHE' VUE NON PUO' GESTIRE DIRETTAMENTE IL V-MODEL ALL'ITERNO DEL CHILD COMPONENT
            localValue:global.utils.clone(this.modelValue)
        }
    },
    methods: {
        esportazione:function(formato){
            this.$emit('esportazione',formato);
        }
    },
    computed: {
    
    },
    watch: {
        localValue:function(){
            this.$emit('update:modelValue', this.localValue)
        }
    },
}

</script>